import withLayout from 'apps/web-client/src/hoc/with-layout';

import { TrainingMatrixController } from './training-matrix.controller';

const TrainingMatrixScreen: React.FC = () => {
  return <TrainingMatrixController />;
};

export default withLayout(TrainingMatrixScreen);
